import { render, staticRenderFns } from "./OnsitePhotosDrawer.vue?vue&type=template&id=4489dcda&scoped=true"
import script from "./OnsitePhotosDrawer.vue?vue&type=script&lang=ts"
export * from "./OnsitePhotosDrawer.vue?vue&type=script&lang=ts"
import style0 from "./OnsitePhotosDrawer.vue?vue&type=style&index=0&id=4489dcda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489dcda",
  null
  
)

export default component.exports